import { createStyles, makeStyles } from '@mui/styles';
import { Theme } from '@mui/material/styles';

const useStyles = makeStyles((theme: Theme) => {
    return createStyles({
        tableMinCostPerSquareFootVersions_title: {
            display: 'inline-flex',
        },
        tableMinCostPerSquareFootVersions_rowIcons: {
            padding: theme.spacing(0, 1, 0, 0),
        },
        tableMinCostPerSquareFootVersions_headerInfoButtonIcon: {
            marginLeft: theme.spacing(1.5),
        },
    });
});

export default useStyles;